import { render, staticRenderFns } from "./ToutiaoProject.vue?vue&type=template&id=2bedff8c&scoped=true"
import script from "./ToutiaoProject.vue?vue&type=script&lang=js"
export * from "./ToutiaoProject.vue?vue&type=script&lang=js"
import style0 from "./ToutiaoProject.vue?vue&type=style&index=0&id=2bedff8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bedff8c",
  null
  
)

export default component.exports